module.exports = __webpack_public_path__ + "img/standard-definition.6f0242a5.svg";